import { Divider, IconButton, InputBase, Paper } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import ArrowDown from "@material-ui/icons/ArrowDropDown";
import SearchIcon from "@material-ui/icons/Search";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { FC } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { GetTranslation } from "../../../translations/GetTranslation";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "2px 2px",
      display: "flex",
      alignItems: "center",
      height: 35,
      width: 400,
      marginLeft: "auto",
      textAlign: "right",
      position: "relative",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: theme.palette.primary.main,
    },
    input: {
      marginLeft: 5,
      flex: 1,
      "& >.MuiInputBase-input": {
        padding: "4px 0 0",
      },
    },
    iconButton: {
      padding: 5,
      color: theme.palette.primary.main,
    },
    divider: {
      height: 23,
      margin: 4,
      background: theme.palette.primary.main,
    },
  })
);

type CustomSearchBoxProps = {
  searchToken: string;
  onChange: (event: any) => void;
  tag?: boolean;
  onClick?: (event: any) => void;
} & WrappedComponentProps;

const CustomSearchBox: FC<CustomSearchBoxProps> = (props) => {
  const { onChange, searchToken, tag, onClick, intl } = props;
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={0}>
      <InputBase
        className={classes.input}
        value={searchToken}
        onChange={onChange}
        placeholder={`${GetTranslation(intl, "common.search")}…`}
      />
      <IconButton className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      {tag && (
        <React.Fragment>
          <Divider className={classes.divider} orientation="vertical" light={true} />
          <IconButton className={classes.iconButton} aria-label="directions" onClick={onClick}>
            <ArrowDown />
          </IconButton>
        </React.Fragment>
      )}
    </Paper>
  );
};

export default injectIntl(CustomSearchBox);
